
import React from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';
import useCountAnimation from '../../hooks/useCountAnimation';
import ProfitsGraph from '../../components/ProfitsGraph';
import horse_promo from '../../assets/horse-promo-example-betslips-and-tips.png';
import megaboost from '../../assets/megaboost-example-betslips-and-tips.png';
import './BetslipsTips.css';

const BetslipsTips = () => {
  /*const [currentSlide, setCurrentSlide] = useState(0);*/
  const [featureRef, featureInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  /*
  const [exampleRef, exampleInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  */

  const features = [
    {
      title: "Horse Racing Promotions",
      description: "Complete promotional system for horse racing with automated calculations and real-time updates",
      icon: "🏇"
    },
    {
      title: "Promotional +EV System",
      description: "Identify and capitalize on profitable promotional offers across all major bookmakers",
      icon: "📈"
    },
    {
      title: "Bet Returns Strategy",
      description: "Strategic bet placement algorithms to maximize your returns on investment",
      icon: "💰"
    },
    {
      title: "NRL Expert Tips",
      description: "Professional analysis and predictions for NRL matches with proven track record",
      icon: "🏉"
    }
  ];

  return (
    <div className="betslips-tips">
      <section className="showcase-intro">
        <div className="showcase-examples">
          <div className="example-card left">
            <img src={horse_promo} alt="Horse Racing Promotions" className="intro-image" />
            <h3>Horse Promotions System</h3>
            <p>Utilise the countless horse bet returns offered every week like never before</p>
          </div>
          <div className="example-card right">
            <img src={megaboost} alt="Megaboost Analysis" className="intro-image" />
            <h3>Sports Promotions System</h3>
            <p>Strike the balance between risk and profit with our carefully selected sport picks</p>
          </div>
        </div>
        <div className="hero-content">
          <div className="hero-stats slide-up-delay-2">
            <div className="stat">
              <span className="stat-number">${useCountAnimation(10622)}</span>
              <span className="stat-label">Total Profit (Dec 31st)</span>
            </div>
            <div className="stat">
              <span className="stat-number">{useCountAnimation(42)}+</span>
              <span className="stat-label">Bookies Covered</span>
            </div>
            <div className="stat">
              <span className="stat-number">{useCountAnimation(16)}</span>
              <span className="stat-label">Sports Covered</span>
            </div>
          </div>
        </div>
      </section>

      <div className="showcase-content">
        <h2>What powers our system?</h2>
        <p>Using modelling and formulae we analyze promotions and betting opportunities across multiple bookmakers to identify the most profitable options. With real-time updates and automated calculations, you can focus on executing the best bets while our system handles the analysis.</p>
      </div>

      <section className="features" ref={featureRef}>
        <div className={`features-grid-betslips ${featureInView ? 'features-visible' : ''}`}>
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      <ProfitsGraph />

      <section className="cta-section">
        <div className="other-bots">
          <h2>Explore Our Other Tools</h2>
          <p>Complete your matched betting toolkit with our specialized bots</p>
          <div className="bot-links">
            <Link to="/conversion-wizard" className="bot-link">
              <span className="bot-icon">🔄</span>
              <div className="bot-info">
                <h3>Conversion Wizard</h3>
                <p>Transform bonus bets into real cash</p>
              </div>
            </Link>
            <Link to="/mug-master" className="bot-link">
              <span className="bot-icon">🎲</span>
              <div className="bot-info">
                <h3>Mug Master</h3>
                <p>Smart account management</p>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BetslipsTips;
